<vex-page-layout>
  <vex-page-layout-content>
    <div class="container">
      <form [formGroup]="loadingOrderForm">
        <div class="header">
          <button
            class="ml-2"
            color="primary"
            mat-stroked-button
            type="button"
            (click)="onBack()">
            <mat-icon svgIcon="mat:arrow_back"></mat-icon> {{"BACK.TEXT"|translate}}
          </button>
          <div class="header-buttons">
            <button
            class="ml-2"
            color="primary"
            mat-flat-button
            routerLink="/transactions/loading-order">
            <mat-icon svgIcon="mat:cancel"></mat-icon> {{"CANCEL.TEXT"|translate}}
          </button>

          <button
          class="ml-2"
          color="primary"
          mat-stroked-button
          (click)="saveAsDraft()">
          <mat-icon svgIcon="mat:drafts"></mat-icon>{{"SAVE_AS_DRAFT.TEXT"|translate}}
        </button>

            <button
              class="ml-2"
              color="primary"
              mat-flat-button
              (click)="send()">
              <mat-icon svgIcon="mat:send"></mat-icon>{{"SEND.TEXT"|translate}}
            </button>
           


          </div>
        </div>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"FROM_FACTORY.TEXT"|translate}}</mat-card-title>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"FACTORY.TEXT"|translate}}</mat-label>
              <input
                matInput
                placeholder="Search Factory"
                formControlName="searchFactory" />

              <mat-select #factorySelect required formControlName="factoryId">
                <mat-option
                  *ngFor="let factory of filteredfactories"
                  [value]="factory.id">
                  {{ factory.code }} - {{ factory.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"TO_CLIENT.TEXT"|translate}}</mat-card-title>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"CLIENT_NAME.TEXT"|translate}}</mat-label>
              <input
                matInput
                placeholder="Search Client"
                formControlName="searchCustomer"
                readonly />

              <mat-select #customerSelect required formControlName="customerId">
                <mat-option
                  *ngFor="let customer of filteredCustomers"
                  [value]="customer.id">
                  {{ customer.code }} - {{ customer.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"LOCATION.TEXT"|translate}}</mat-label>
              <mat-select formControlName="customerAddressId" required>
                <mat-option
                  *ngFor="let location of customerLocations"
                  [value]="location.id"
                  >{{ location.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"PRODUCT_VEHICLE_DETAILS.TEXT"|translate}}</mat-card-title>
            <div class="row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{"PRODUCT.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  placeholder="Search Product"
                  formControlName="searchProduct"
                  readonly />

                <mat-select #productSelect required formControlName="itemId">
                  <mat-option
                    *ngFor="let product of filteredProducts"
                    [value]="product.id">
                    {{ product.code }} - {{ product.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{ "QUANTITY.TEXT" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="quantity"
                  type="number"
                  placeholder="Enter quantity"
                  required />
                <mat-error
                  *ngIf="loadingOrderForm.get('quantity').hasError('required')">
                  Quantity is required
                </mat-error>
                <mat-error
                  *ngIf="loadingOrderForm.get('quantity').hasError('min')">
                  Quantity must be greater than 0
                </mat-error>
                <mat-error
                  *ngIf="
                    loadingOrderForm
                      .get('quantity')
                      .hasError('maxQuantityExceeded')
                  ">
                  Quantity cannot exceed available quantity of
                  {{ AvailableQuantity }}
                </mat-error>
              
                <p style="font-size: 10px; color: #0000af">
                  * Total Requested Quantity For this Sales Order is [
                  {{ totalRequestedQuantity }} ] *
                </p>
              </mat-form-field>

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"TYPE_OF_VEHICLE.TEXT"|translate}}</mat-label>
                <mat-select
                formControlName="vehicleType">
                <mat-option
                *ngFor="let vehicle of vehicleType"
                [value]="IVehicleTypes[vehicle]"> <!-- Access enum value -->
                {{ (vehicle.toUpperCase() + '.TEXT')|translate }} <!-- Display enum key -->
                </mat-option>
              </mat-select>
                <!-- <input
                  matInput
                  placeholder="My description"
                   /> -->
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"ADDITIONAL_DETAILS.TEXT"|translate}}</mat-card-title>

            <div class="row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"CUSTOMER_REFERENCE_NO.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  formControlName="customerRefNo"
                  placeholder="Enter Reference No"
                  required />
              </mat-form-field>
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"TRANSACTION_DATE.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  formControlName="transactionDate"
                  [matDatepicker]="picker" />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"TRANSPORTER.TEXT"|translate}}</mat-label>
              <input
                matInput
                #inputTransporterRef
                placeholder="Search Transporter"
                (input)="filterTransporters($event)" />
              <mat-select
                #transporterSelect
                required
                formControlName="transporterId"
                (selectionChange)="clearSearchText()">
                <mat-option
                  *ngFor="let transporter of filteredTransporters"
                  [value]="transporter.id">
                  {{ transporter.name }} - {{transporter.code}}
                </mat-option>
              </mat-select>
              <div matSuffix class="flex items-center space-x-2">
                <button mat-icon-button (click)="removeTransporterFilter($event)" aria-label="Clear selection">
                  <mat-icon svgIcon="mat:delete"></mat-icon>
                </button>
              </div>
            </mat-form-field>

            <div class="row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"DRIVER.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  #inputDriverRef
                  placeholder="Search Driver"
                  (input)="filterDrivers($event)" />
                <mat-select
                  #driverSelect
                  required
                  formControlName="driverId"
                  (selectionChange)="clearSearchText()">
                  <mat-option
                    *ngFor="let driver of filteredDrivers"
                    [value]="driver.id"
                    [disabled]="shouldDisable(driver)">
                    {{ driver.firstName }} {{ driver.lastName }} ( {{driver.residenceNumber}} ) 
                  </mat-option>
                </mat-select>
                <div matSuffix class="flex items-center space-x-2">
                  <button mat-icon-button (click)="removeDriverFilter($event)" aria-label="Clear selection">
                    <mat-icon svgIcon="mat:delete"></mat-icon>
                  </button>
                </div>
              </mat-form-field>

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"TRUCK.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  #inputVehicleRef
                  placeholder="Search Vehicle"
                  (input)="filterVehicles($event)"
                />
                <mat-select
                #vehicleSelect
                 required formControlName="vehicleId" (selectionChange)="clearSearchText()">
                  <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
                    {{ vehicle.name }}
                  </mat-option>
                </mat-select>
                <div matSuffix class="flex items-center space-x-2">
                  <button mat-icon-button (click)="removeVehicleFilter($event)" aria-label="Clear selection">
                    <mat-icon svgIcon="mat:delete"></mat-icon>
                  </button>
                </div>
              </mat-form-field>

              <!-- <mat-form-field appearance="outline" class="half-width">
                <mat-label>Driver</mat-label>
                <input 
                  matInput 
                  placeholder="Search Driver" 
                  [(ngModel)]="searchTextDriver" 
                  (input)="filterDrivers($event)" 
                />
                <mat-select 
                  #driverSelect
                  required 
                  formControlName="driverId"
                  
                  >
                  <mat-option 
                    *ngFor="let driver of filteredDrivers" 
                    [value]="driver.id">
                    {{ driver.firstName }} {{ driver.lastName }}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->

              <!-- <mat-form-field appearance="outline" class="half-width">
                <mat-label>Driver</mat-label>
                <mat-select required formControlName="driverId">
                  <mat-option *ngFor="let driver of drivers" [value]="driver.id"
                    >{{ driver.firstName }} {{ driver.lastName }}</mat-option
                  >
                </mat-select>
              </mat-form-field> -->
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    </div>
  </vex-page-layout-content>
</vex-page-layout>
